import React from 'react';

export const PostgreSqlLogo = () => {
  return (
    <svg className="stack-icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <title>Logo PostgreSQL</title>
      <g id="uuid-a8bd30f6-b407-45ef-8eb8-23f58aea62bb">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" />
        <g id="uuid-1bae9d5e-1227-4ba7-8186-4434c372bb85">
          <path
            d="M63.8,66.9c.4-3,.3-3.4,2.5-3h.6c1.7,.1,4-.2,5.3-.8,2.8-1.3,4.5-3.5,1.7-2.9-6.4,1.3-6.8-.8-6.8-.8,6.7-10,9.6-22.7,7.1-25.8-6.6-8.5-18.1-4.5-18.3-4.4h0c-1.3-.3-2.7-.4-4.3-.4-2.9,0-5.1,.8-6.7,2,0,0-20.5-8.4-19.5,10.6,.2,4.1,5.8,30.7,12.5,22.6,2.4-2.9,4.8-5.4,4.8-5.4,1.2,.8,2.6,1.2,4.1,1h.1c0,.3,0,.6,0,1-1.7,1.9-1.2,2.3-4.7,3-3.5,.7-1.4,2-.1,2.3,1.6,.4,5.4,1,7.9-2.6v.4c.6,.5,.5,3.9,.6,6.3,0,2.4,.3,4.6,.7,5.9,.5,1.3,1.1,4.7,5.6,3.7,3.8-.8,6.7-2,6.9-12.8"
            stroke="#000"
            strokeWidth="4.7"
          />
          <path
            d="M73.8,60.2c-6.4,1.3-6.8-.8-6.8-.8,6.7-10,9.6-22.7,7.1-25.8-6.6-8.5-18.1-4.5-18.3-4.4h0c-1.3-.3-2.7-.4-4.3-.4-2.9,0-5.1,.8-6.7,2,0,0-20.5-8.4-19.5,10.6,.2,4.1,5.8,30.7,12.5,22.6,2.4-2.9,4.8-5.4,4.8-5.4,1.2,.8,2.6,1.2,4.1,1h.1c0,.3,0,.6,0,1-1.7,1.9-1.2,2.3-4.7,3-3.5,.7-1.4,2-.1,2.3,1.6,.4,5.4,1,7.9-2.6v.4c.6,.5,1,3.5,1,6.2,0,2.7-.1,4.6,.4,6,.5,1.4,1.1,4.7,5.6,3.7,3.8-.8,5.7-2.9,6-6.4,.2-2.5,.6-2.1,.7-4.4l.4-1.1c.4-3.4,0-4.5,2.4-4h.6c1.7,.1,4-.2,5.3-.8,2.8-1.3,4.5-3.5,1.7-2.9h0Z"
            fill="#336791"
          />
          <path
            d="M50.1,62.1c-.2,6.3,0,12.6,.7,14.2,.6,1.5,1.9,4.5,6.5,3.6,3.8-.8,5.2-2.4,5.8-5.8,.4-2.6,1.3-9.6,1.4-11.1"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            d="M44.7,30.6s-20.5-8.4-19.6,10.7c.2,4.1,5.8,30.7,12.5,22.6,2.4-2.9,4.7-5.2,4.7-5.2"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            d="M55.8,29c-.7,.2,11.4-4.4,18.3,4.4,2.4,3.1-.4,15.8-7.1,25.8"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            d="M67,59.2s.4,2.2,6.8,.8c2.8-.6,1.1,1.6-1.7,2.9-2.3,1.1-7.6,1.4-7.6-.1-.2-3.9,2.7-2.7,2.5-3.6-.2-.9-1.5-1.7-2.4-3.9-.8-1.9-10.5-16.1,2.7-14,.5-.1-3.4-12.6-15.8-12.8-12.4-.2-12,15.2-12,15.2"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="bevel"
            strokeWidth="1.6"
          />
          <path
            d="M46.7,60.5c-1.7,1.9-1.2,2.3-4.7,3-3.5,.7-1.4,2-.1,2.3,1.6,.4,5.4,1,7.9-2.6,.8-1.1,0-2.8-1.1-3.2-.5-.2-1.2-.5-2.1,.5h0Z"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            d="M46.6,60.5c-.2-1.1,.4-2.5,1-4.1,.9-2.4,2.9-4.7,1.3-12.2-1.2-5.6-9.3-1.2-9.3-.4,0,.8,.4,3.8-.1,7.4-.7,4.7,3,8.7,7.2,8.2"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
          <path
            d="M44.6,43.7c0,.3,.5,.9,1.1,1,.7,0,1.2-.4,1.3-.7,0-.3-.5-.5-1.1-.6-.7,0-1.2,0-1.3,.3h0Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth=".5"
          />
          <path
            d="M64.9,43.2c0,.3-.5,.9-1.1,1-.7,0-1.2-.4-1.3-.7,0-.3,.5-.5,1.1-.6s1.2,0,1.3,.3h0Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth=".3"
          />
          <path
            d="M67.3,41.4c.1,2-.4,3.4-.5,5.6-.1,3.1,1.5,6.7-.9,10.3"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.6"
          />
        </g>
      </g>
    </svg>
  );
};
